<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill:none;stroke:#273142;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:0.65;}
</style>
<path class="st0" d="M1,12c0,0,4-8,11-8s11,8,11,8s-4,8-11,8S1,12,1,12z"/>
<path class="st0" d="M12,15c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3S10.3,15,12,15z"/>
</svg>
